import * as React from "react";
const LawIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 47.875 48",
  "aria-hidden": "true",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36.938 44h-11V7h10.3l-4.721 11.953a1.497 1.497 0 1 0 2.785 1.1L38.438 9.58l4.136 10.473a1.497 1.497 0 1 0 2.785-1.1L39.828 4.95a1.488 1.488 0 0 0-1.39-.95h-12.5V2a2 2 0 0 0-4 0v2h-12.5a1.488 1.488 0 0 0-1.39.95L2.517 18.953a1.497 1.497 0 1 0 2.785 1.1L9.438 9.58l4.136 10.473a1.497 1.497 0 1 0 2.785-1.1L11.637 7h10.3v37h-11a2 2 0 1 0 0 4h26a2 2 0 0 0 0-4z",
  style: {
    fill: "#000"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.869 24.312a.257.257 0 0 0-.25-.312H.256a.257.257 0 0 0-.25.312 9.696 9.696 0 0 0 18.863 0zM47.62 24H29.255a.257.257 0 0 0-.25.312 9.696 9.696 0 0 0 18.863 0 .257.257 0 0 0-.25-.312z",
  style: {
    fill: "#000"
  }
})));
export default LawIcon;